<template>
  <AppSection :title="title" padding="0">
    <div v-if="extras && selected">
      <!--<ul class="extras-tabs" v-if="extras.length > 1">
        <li class="extra-tab"
            :class="getTabClass(extra)"
            v-for="extra in extras"
            @click="selected = extra"
        >{{extra.DESCRIPCION}}
        </li>
      </ul>

      v-if="extra.CODMODIFICADOR === selected.CODMODIFICADOR"

      -->
      <ProductExtras
          v-for="extra in extras" :key="extra.CODMODIFICADOR"
          :extras="{extra}"
          @optionSelected="onOptionSelected"
      />
    </div>

  </AppSection>
</template>
<script>
  import ProductExtras from '../Products/ProductExtras'

  export default {
    components: {ProductExtras},
    props: {
      title: {type: String},
      extras: {},
    },
    data() {
      return {
        selected: null,
      }
    },
    mounted() {
      this.selected = this.extras[0]
    },
    methods: {
      onOptionSelected(option) {
        this.$emit('onOptionSelected', option)
      },
      getTabClass(extra) {
        return extra.CODMODIFICADOR === this.selected.CODMODIFICADOR ? 'active' : ''
      },
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/Order/ProductExtrasSelector.vue